// 🔎♥ QUICK FIND SHEET — on-map shortcut to saved merchants (opens via "airpog:quick-find").
import { useEffect, useState } from "react";
import { X } from "lucide-react";
import { QuickFindMerchants } from "@/hq/QuickFindMerchants";

export const QuickFindSheet = () => {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const on = () => setOpen(true);
    window.addEventListener("airpog:quick-find", on);
    return () => window.removeEventListener("airpog:quick-find", on);
  }, []);
  if (!open) return null;
  return (
    <div data-testid="quick-find-sheet" className="fixed inset-0 z-[2200] flex items-end justify-center">
      <div className="absolute inset-0 bg-slate-950/60 backdrop-blur-sm" onClick={() => setOpen(false)} />
      <div className="relative w-full max-w-md bg-slate-900 border-t-2 border-rose-400/60 rounded-t-3xl p-4 pb-[calc(1.5rem+env(safe-area-inset-bottom))] max-h-[80vh] overflow-y-auto">
        <button data-testid="quick-find-close" onClick={() => setOpen(false)}
          className="absolute top-4 right-4 z-10 w-8 h-8 rounded-full bg-slate-800 hover:bg-slate-700 flex items-center justify-center">
          <X className="w-4 h-4 text-slate-300" />
        </button>
        <QuickFindMerchants />
      </div>
    </div>
  );
};
